<template>
  <div>
    <div class="b-dialog__top-panel mb-4">
      <h2>{{ title }}</h2>
      <button class="b-btn b-btn_border_none" @click="onClose">
        <dynamic-icon icon="close"/>
      </button>
    </div>
    <div class="b-dialog__form">
      <div class="b-server-error mb-5" v-if="type==='error'">
        <div class="b-server-error__icon-wrap p-4">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" class="">
            <path fill-rule="evenodd"
                  d="M9 11.2h2V7.244H9V11.2zm1 3.91a.955.955 0 110-1.912.955.955 0 010 1.911zm7.871.567l-7.044-12.2a.954.954 0 00-1.653 0l-7.045 12.2a.955.955 0 00.827 1.432h14.086a.956.956 0 00.83-1.432z"/>
          </svg>
        </div>
        <div class="m-5">{{ message }}</div>
      </div>
      <div class="mb-5" v-else>{{ message }}</div>
      <button class="b-btn b-btn__color-lightgray ml-auto" @click="onClose">OK</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'notification-popup',
  props: {
    type: {
      type: String // error
    },
    title: {
      type: String,
      default: 'Title'
    },
    message: {
      type: String,
      default: 'Message'
    },
  },
  methods: {
    onClose() {
      this.$emit('onClose');
    }
  }
};
</script>
